import { createSlice } from "@reduxjs/toolkit";

type Payload = {
  startDate: string | null;
  endDate: string | null;
  truck: string | null;
};

type State = {
  payload: Payload;
};

const slice = createSlice({
  name: "biiSortDates",
  initialState: { payload: { startDate: "", endDate: "", truck: "" } } as State,
  reducers: {
    getBIISortDates: (state, { payload }: { payload: Payload }) => {
      state.payload = payload;
    }
  }
});

export const { getBIISortDates } = slice.actions;
export default slice.reducer;
